/**
 * Injects header content into a page
 *
 * @param {string} header - The header text
 * @param {string} subheader - The subheader text
 * @param 
 */
export default function createPageHeader(header, subheader) {
    try {
        let mainContainer = document.querySelector('#main-container');
        let searchContainer = document.querySelector('.search-container');

        let pageHeader = document.createElement('H1');
        pageHeader.innerText = header;

        let subText = document.createElement('H2');
        subText.innerText = subheader;

        searchContainer.prepend(pageHeader);
        searchContainer.append(subText);

        mainContainer.prepend(searchContainer);
    } catch {
    }
};
